// Review display colour presets, copied from trustshop-fe
// src/config/defaultReviewDisplaySetting.js (reviewDisplayColorPreset). Keep in sync:
// a named color_mode resolves its colours from here, not from the saved palette.
const reviewDisplayColorPreset = {
    light: {
        primary_color: "#3D4153",
        secondary_color: "#FFFFFF",
        title_text_color: "#111111",
        all_photos_button_color: "#005BD3",
        slide_button: "#FFFFFF",
        slide_arrow: "#4A4A4A",
        primary_text_color: "#111111",
        secondary_text_color: "rgba(17, 17, 17, 0.6)",
        star_icon_color: "#FFB400",
        star_icon_empty_color: "rgba(17, 17, 17, 0.1)",
        line_color: "rgba(17, 17, 17, 0.1)",
        filter_sort_background: "#F2F2F6",
        filter_sort_text: "#3D4153",
        rating_process_color: "#FFB400",
        rating_process_empty_color: "rgba(17, 17, 17, 0.1)",
        user_name_color: "#111111",
        load_more_color: "#3D4153",
        bg_base_color: "rgba(255, 255, 255, 0)",
        reply_title_color: "#111111",
        reply_content_color: "#111111",
        review_card_background: "#FFFFFF",
        modal_detail_card_background: "#FFFFFF",
        modal_detail_text: "#111111",
        summary_background: "rgba(255, 255, 255, 0)",
        reply_background_color: "rgba(17, 17, 17, 0.03)",
        primary_btn_bg_color: "#111111",
        primary_btn_border_color: "#111111",
        primary_btn_text_color: "#FFFFFF",
        secondary_btn_bg_color: "#FFFFFF",
        secondary_btn_border_color: "rgba(17, 17, 17, 0.1)",
        secondary_btn_text_color: "#111111",
        plain_btn_text_color: "rgba(17, 17, 17, 0.6)",
        nav_btn_bg_color: "#FFFFFF",
        nav_btn_icon_color: "#111111",
        // Status icons: a merchant-editable colour, but the same value in
        // every theme — green means approved and amber means pending
        // regardless of palette. Carried by each preset so switching colour
        // mode always publishes the key; a preset that omitted it would
        // leave --modal_submitted_review_*_popup_icon unresolved and paint
        // the icon black.
        modal_submitted_review_success_popup_icon: "#28A52D",
        modal_submitted_review_pending_popup_icon: "#FFB400",
    },
    dark: {
        primary_color: "#FFFFFF",
        secondary_color: "#3D4153",
        title_text_color: "#FFFFFF",
        all_photos_button_color: "#005BD3",
        slide_button: "#FFFFFF",
        slide_arrow: "#4A4A4A",
        primary_text_color: "#FFFFFF",
        secondary_text_color: "rgba(255, 255, 255, 0.6)",
        star_icon_color: "#FFB400",
        star_icon_empty_color: "rgba(255, 255, 255, 0.2)",
        line_color: "rgba(255, 255, 255, 0.1)",
        filter_sort_background: "#434343",
        filter_sort_text: "#FFFFFF",
        rating_process_color: "#FFB400",
        rating_process_empty_color: "rgba(255, 255, 255, 0.2)",
        user_name_color: "#FFFFFF",
        load_more_color: "#FFFFFF",
        bg_base_color: "rgba(17, 17, 17, 0)",
        reply_title_color: "#FFFFFF",
        reply_content_color: "#FFFFFF",
        review_card_background: "#1F1F1F",
        modal_detail_card_background: "#111111",
        modal_detail_text: "#FFFFFF",
        summary_background: "rgba(31, 31, 31, 0)",
        reply_background_color: "rgba(255, 255, 255, 0.06)",
        primary_btn_bg_color: "#FFFFFF",
        primary_btn_border_color: "#FFFFFF",
        primary_btn_text_color: "#111111",
        secondary_btn_bg_color: "rgba(255, 255, 255, 0.2)",
        secondary_btn_border_color: "rgba(255, 255, 255, 0)",
        secondary_btn_text_color: "#FFFFFF",
        plain_btn_text_color: "rgba(255, 255, 255, 0.6)",
        nav_btn_bg_color: "rgba(255, 255, 255, 0.1)",
        nav_btn_icon_color: "#FFFFFF",
        modal_submitted_review_success_popup_icon: "#28A52D",
        modal_submitted_review_pending_popup_icon: "#FFB400",
    },
    custom: {
        primary_color: "#3D4153",
        secondary_color: "#FFFFFF",
        title_text_color: "#111111",
        all_photos_button_color: "#005BD3",
        slide_button: "#FFFFFF",
        slide_arrow: "#4A4A4A",
        primary_text_color: "#111111",
        secondary_text_color: "rgba(17, 17, 17, 0.6)",
        star_icon_color: "#FFB400",
        star_icon_empty_color: "rgba(17, 17, 17, 0.1)",
        line_color: "rgba(17, 17, 17, 0.1)",
        filter_sort_background: "#F2F2F6",
        filter_sort_text: "#3D4153",
        rating_process_color: "#FFB400",
        rating_process_empty_color: "rgba(17, 17, 17, 0.1)",
        user_name_color: "#111111",
        load_more_color: "#3D4153",
        bg_base_color: "rgba(255, 255, 255, 0)",
        reply_title_color: "#111111",
        reply_content_color: "#111111",
        review_card_background: "#FFFFFF",
        modal_detail_card_background: "#FFFFFF",
        modal_detail_text: "#111111",
        summary_background: "rgba(255, 255, 255, 0)",
        reply_background_color: "rgba(17, 17, 17, 0.03)",
        primary_btn_bg_color: "#111111",
        primary_btn_border_color: "#111111",
        primary_btn_text_color: "#FFFFFF",
        secondary_btn_bg_color: "#FFFFFF",
        secondary_btn_border_color: "rgba(17, 17, 17, 0.1)",
        secondary_btn_text_color: "#111111",
        plain_btn_text_color: "rgba(17, 17, 17, 0.6)",
        nav_btn_bg_color: "#FFFFFF",
        nav_btn_icon_color: "#111111",
        modal_submitted_review_success_popup_icon: "#28A52D",
        modal_submitted_review_pending_popup_icon: "#FFB400",
    },
    // Inherits every key not shown in the design from the light palette.
    matcha: {
        primary_color: "#3D4153",
        secondary_color: "#FFFFFF",
        title_text_color: "#21652F",
        all_photos_button_color: "#005BD3",
        slide_button: "#FFFFFF",
        slide_arrow: "#4A4A4A",
        primary_text_color: "#111111",
        secondary_text_color: "rgba(17, 17, 17, 0.6)",
        star_icon_color: "#21652F",
        star_icon_empty_color: "rgba(17, 17, 17, 0.1)",
        line_color: "rgba(17, 17, 17, 0.1)",
        filter_sort_background: "#F2F2F6",
        filter_sort_text: "#3D4153",
        rating_process_color: "#21652F",
        rating_process_empty_color: "rgba(17, 17, 17, 0.1)",
        user_name_color: "#111111",
        load_more_color: "#3D4153",
        bg_base_color: "rgba(245, 235, 210, 0)",
        reply_title_color: "#111111",
        reply_content_color: "#111111",
        review_card_background: "#FFF8E6",
        modal_detail_card_background: "#FFF8E6",
        modal_detail_text: "#111111",
        summary_background: "rgba(255, 248, 230, 0)",
        reply_background_color: "#FFF8E6",
        primary_btn_bg_color: "#21652F",
        primary_btn_border_color: "#21652F",
        primary_btn_text_color: "#FFFFFF",
        secondary_btn_bg_color: "#E9DCB9",
        secondary_btn_border_color: "#E9DCB9",
        secondary_btn_text_color: "#6F540D",
        plain_btn_text_color: "rgba(17, 17, 17, 0.6)",
        nav_btn_bg_color: "#FFF8E6",
        nav_btn_icon_color: "#21652F",
        modal_submitted_review_success_popup_icon: "#28A52D",
        modal_submitted_review_pending_popup_icon: "#FFB400",
    },
    // Inherits every key not shown in the design from the light palette.
    ocean: {
        primary_color: "#3D4153",
        secondary_color: "#FFFFFF",
        title_text_color: "#23579E",
        all_photos_button_color: "#005BD3",
        slide_button: "#FFFFFF",
        slide_arrow: "#4A4A4A",
        primary_text_color: "#111111",
        secondary_text_color: "rgba(17, 17, 17, 0.6)",
        star_icon_color: "#23579E",
        star_icon_empty_color: "rgba(17, 17, 17, 0.1)",
        line_color: "rgba(17, 17, 17, 0.1)",
        filter_sort_background: "#F2F2F6",
        filter_sort_text: "#3D4153",
        rating_process_color: "#23579E",
        rating_process_empty_color: "rgba(17, 17, 17, 0.1)",
        user_name_color: "#111111",
        load_more_color: "#3D4153",
        bg_base_color: "rgba(238, 242, 249, 0)",
        reply_title_color: "#111111",
        reply_content_color: "#111111",
        review_card_background: "#F8FAFF",
        modal_detail_card_background: "#F8FAFF",
        modal_detail_text: "#111111",
        summary_background: "rgba(248, 250, 255, 0)",
        reply_background_color: "#F8FAFF",
        primary_btn_bg_color: "#23579E",
        primary_btn_border_color: "#23579E",
        primary_btn_text_color: "#FFFFFF",
        secondary_btn_bg_color: "#FFFFFF",
        secondary_btn_border_color: "#23579E",
        secondary_btn_text_color: "#23579E",
        plain_btn_text_color: "rgba(17, 17, 17, 0.6)",
        nav_btn_bg_color: "#FFFFFF",
        nav_btn_icon_color: "#23579E",
        modal_submitted_review_success_popup_icon: "#28A52D",
        modal_submitted_review_pending_popup_icon: "#FFB400",
    },
    // Inherits every key not shown in the design from the light palette.
    coconut: {
        primary_color: "#3D4153",
        secondary_color: "#FFFFFF",
        title_text_color: "#B46C25",
        all_photos_button_color: "#005BD3",
        slide_button: "#FFFFFF",
        slide_arrow: "#4A4A4A",
        primary_text_color: "#111111",
        secondary_text_color: "rgba(17, 17, 17, 0.6)",
        star_icon_color: "#B46C25",
        star_icon_empty_color: "rgba(17, 17, 17, 0.1)",
        line_color: "rgba(17, 17, 17, 0.1)",
        filter_sort_background: "#F2F2F6",
        filter_sort_text: "#3D4153",
        rating_process_color: "#B46C25",
        rating_process_empty_color: "rgba(17, 17, 17, 0.1)",
        user_name_color: "#111111",
        load_more_color: "#3D4153",
        bg_base_color: "rgba(251, 241, 231, 0)",
        reply_title_color: "#111111",
        reply_content_color: "#111111",
        review_card_background: "#F2E1CF",
        modal_detail_card_background: "#F2E1CF",
        modal_detail_text: "#111111",
        summary_background: "rgba(242, 225, 207, 0)",
        reply_background_color: "#F2E1CF",
        primary_btn_bg_color: "#B46C25",
        primary_btn_border_color: "#B46C25",
        primary_btn_text_color: "#FFFFFF",
        secondary_btn_bg_color: "#F2E1CF",
        secondary_btn_border_color: "#F2E1CF",
        secondary_btn_text_color: "#B46C25",
        plain_btn_text_color: "rgba(17, 17, 17, 0.6)",
        nav_btn_bg_color: "#FFFFFF",
        nav_btn_icon_color: "#B46C25",
        modal_submitted_review_success_popup_icon: "#28A52D",
        modal_submitted_review_pending_popup_icon: "#FFB400",
    },
    // Inherits every key not shown in the design from the light palette.
    marshmallow: {
        primary_color: "#3D4153",
        secondary_color: "#FFFFFF",
        title_text_color: "#EF7C97",
        all_photos_button_color: "#005BD3",
        slide_button: "#FFFFFF",
        slide_arrow: "#4A4A4A",
        primary_text_color: "#111111",
        secondary_text_color: "rgba(17, 17, 17, 0.6)",
        star_icon_color: "#EF7C97",
        star_icon_empty_color: "rgba(17, 17, 17, 0.1)",
        line_color: "rgba(17, 17, 17, 0.1)",
        filter_sort_background: "#F2F2F6",
        filter_sort_text: "#3D4153",
        rating_process_color: "#EF7C97",
        rating_process_empty_color: "rgba(17, 17, 17, 0.1)",
        user_name_color: "#111111",
        load_more_color: "#3D4153",
        bg_base_color: "rgba(253, 243, 245, 0)",
        reply_title_color: "#111111",
        reply_content_color: "#111111",
        review_card_background: "#F5E6E9",
        modal_detail_card_background: "#F5E6E9",
        modal_detail_text: "#111111",
        summary_background: "rgba(245, 230, 233, 0)",
        reply_background_color: "#F5E6E9",
        primary_btn_bg_color: "#EF7C97",
        primary_btn_border_color: "#EF7C97",
        primary_btn_text_color: "#FFFFFF",
        secondary_btn_bg_color: "#FFFFFF",
        secondary_btn_border_color: "#EF7C97",
        secondary_btn_text_color: "#EF7C97",
        plain_btn_text_color: "rgba(17, 17, 17, 0.6)",
        nav_btn_bg_color: "#FFFFFF",
        nav_btn_icon_color: "#EF7C97",
        modal_submitted_review_success_popup_icon: "#28A52D",
        modal_submitted_review_pending_popup_icon: "#FFB400",
    },
    // Inherits every key not shown in the design from the dark palette.
    lemon_dark: {
        primary_color: "#FFFFFF",
        secondary_color: "#3D4153",
        title_text_color: "#FFFFFF",
        all_photos_button_color: "#005BD3",
        slide_button: "#FFFFFF",
        slide_arrow: "#4A4A4A",
        primary_text_color: "#FFFFFF",
        secondary_text_color: "rgba(255, 255, 255, 0.6)",
        star_icon_color: "#FFB400",
        star_icon_empty_color: "rgba(255, 255, 255, 0.2)",
        line_color: "rgba(255, 255, 255, 0.1)",
        filter_sort_background: "#434343",
        filter_sort_text: "#FFFFFF",
        rating_process_color: "#FFB400",
        rating_process_empty_color: "rgba(255, 255, 255, 0.2)",
        user_name_color: "#FFFFFF",
        load_more_color: "#FFFFFF",
        bg_base_color: "rgba(39, 51, 0, 0)",
        reply_title_color: "#FFFFFF",
        reply_content_color: "#FFFFFF",
        review_card_background: "#343F0F",
        modal_detail_card_background: "#343F0F",
        modal_detail_text: "#FFFFFF",
        summary_background: "rgba(52, 63, 15, 0)",
        reply_background_color: "rgba(255, 255, 255, 0.06)",
        primary_btn_bg_color: "#799E00",
        primary_btn_border_color: "#799E00",
        primary_btn_text_color: "#FFFFFF",
        secondary_btn_bg_color: "rgba(121, 158, 0, 0)",
        secondary_btn_border_color: "#799E00",
        secondary_btn_text_color: "rgba(255, 255, 255, 0.6)",
        plain_btn_text_color: "rgba(255, 255, 255, 0.7)",
        nav_btn_bg_color: "#F1E6E0",
        nav_btn_icon_color: "#799E00",
        modal_submitted_review_success_popup_icon: "#28A52D",
        modal_submitted_review_pending_popup_icon: "#FFB400",
    },
};

export default reviewDisplayColorPreset;
